// socket-plugin.js
import Vue from 'vue';
import io from 'socket.io-client';
import VueSocketIoExt from 'vue-socket.io-extended';
import config from "@/core/config";

export const socket = io(config.ioURL, {
  autoConnect: false,
  withCredentials: false
});

export default function (store) {
  Vue.use(VueSocketIoExt, socket, { store });
}
